// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workspaceSectionLabel_lDXTD {
  padding: 20px 0;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

p{
    margin: 0;
}
.descSection_gaKd2{
    font-size: 15px;
    color: #717171;
}
  .accessInfo_zOe3P {
    display: flex;
    text-align: end;
    align-items: center;
    gap: 10px;
    p {
      margin: 0;
    }
    .access_UQkaL {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    .accessType_iFQKn {
      color: var(--_10a37f-background);
      font-size: 13px;
    }
    .rol_yL3c3 {
      font-size: 13px;
      color: #717171;
    }
    img {
      width: 30px;
      height: 30px;
      border-radius: 999px;
    }
  }

  .spendingControls_Pgo6g{
    width: fit-content;
    display: flex;
    gap: 10px;
    .inputContainer_Q_gXw{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    input{
        width: fit-content;
        width: 100px;
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: 400;
        color: var(--_75-color);
        min-height: 21px !important;
        background-color: var(--f4-background);
        border-radius: 5px;
        font-family: "Inter", sans-serif;
        box-sizing: border-box;
        width: 100%;
        field-sizing: content;
        min-height: 21px !important;
        padding: 8px 4px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewWorkspace/WorkspaceSection/WorkspaceSection.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;;AAEX;IACI,SAAS;AACb;AACA;IACI,eAAe;IACf,cAAc;AAClB;EACE;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT;MACE,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;IACV;IACA;MACE,gCAAgC;MAChC,eAAe;IACjB;IACA;MACE,eAAe;MACf,cAAc;IAChB;IACA;MACE,WAAW;MACX,YAAY;MACZ,oBAAoB;IACtB;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,2BAA2B;QAC3B,sCAAsC;QACtC,kBAAkB;QAClB,gCAAgC;QAChC,sBAAsB;QACtB,WAAW;QACX,qBAAqB;QACrB,2BAA2B;QAC3B,gBAAgB;IACpB;EACF;AACF","sourcesContent":[".workspaceSectionLabel {\n  padding: 20px 0;\n  border-bottom: 1px solid #ebebeb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n\np{\n    margin: 0;\n}\n.descSection{\n    font-size: 15px;\n    color: #717171;\n}\n  .accessInfo {\n    display: flex;\n    text-align: end;\n    align-items: center;\n    gap: 10px;\n    p {\n      margin: 0;\n    }\n    .access {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n    }\n    .accessType {\n      color: var(--_10a37f-background);\n      font-size: 13px;\n    }\n    .rol {\n      font-size: 13px;\n      color: #717171;\n    }\n    img {\n      width: 30px;\n      height: 30px;\n      border-radius: 999px;\n    }\n  }\n\n  .spendingControls{\n    width: fit-content;\n    display: flex;\n    gap: 10px;\n    .inputContainer{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    input{\n        width: fit-content;\n        width: 100px;\n        border: none;\n        outline: none;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_75-color);\n        min-height: 21px !important;\n        background-color: var(--f4-background);\n        border-radius: 5px;\n        font-family: \"Inter\", sans-serif;\n        box-sizing: border-box;\n        width: 100%;\n        field-sizing: content;\n        min-height: 21px !important;\n        padding: 8px 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspaceSectionLabel": `workspaceSectionLabel_lDXTD`,
	"descSection": `descSection_gaKd2`,
	"accessInfo": `accessInfo_zOe3P`,
	"access": `access_UQkaL`,
	"accessType": `accessType_iFQKn`,
	"rol": `rol_yL3c3`,
	"spendingControls": `spendingControls_Pgo6g`,
	"inputContainer": `inputContainer_Q_gXw`
};
export default ___CSS_LOADER_EXPORT___;
